var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 您没有该功能的操作权限，请联系管理员开通 ")])}
var staticRenderFns = []

export { render, staticRenderFns }